import { compileContent } from "#scripts/tools/compile_content.js";
import { compileResources } from "#scripts/compile.js";
import { decodeIfNeeded } from "#templates/pages/content";

export const getArticle = async (contentId, subscriptionId) => {
	if (!contentId) {
		return;
	}

	let apiLang = "nb_no";
	switch (window.serverdata.configMeta.aim.lang) {
		case "nb":
		case "nn":
			apiLang = `${window.serverdata.configMeta.aim.lang}_no`;
			break;
		case "en":
			apiLang = "en_us";
			break;
	}
	apiLang = localStorage.getItem("currentLanguage") || apiLang;

	let apiParameters = "";
	let apiCall = `${window.apiUrl}/Public/articles`;
	apiParameters = `/${contentId}?subscriptionId=${subscriptionId}&language=${apiLang}&includeCategories=true&getRecursiveContent=true`;
	let html = "";

	await fetch(apiCall + apiParameters)
		.then((results) => results.json())
		.then((data) => {
			html = decodeIfNeeded(data.contentObject);
			html = compileContent(html, data);
			html = compileResources(html);
		});

	return html;
};

export const getLangForApi = () => {
	let apiLang = "nb_no";
	switch (window.serverdata.configMeta.aim.lang) {
		case "nb":
		case "nn":
			apiLang = `${window.serverdata.configMeta.aim.lang}_no`;
			break;
		case "en":
			apiLang = "en_us";
			break;
	}
	return localStorage.getItem("currentLanguage") || apiLang;
};
